import finsightWebUrl from '@/finsight/infrastructure/finsightWebUrl';

const getLoanLevelMetaSchema = () => ({
  '@type': 'WebPage',
  url: finsightWebUrl.getProductLoanLevelUrl(),
  name: 'US ABS Loan Level Data on EDGAR Tracker',
  description: 'View and track the latest ABS-EE loan level-data filings on EDGAR here.',
  keywords: ['asset-backed securities', 'United States', 'EDGAR'],
});

export default getLoanLevelMetaSchema;
